import { LocationModel } from '../../../locations/location.model';

export namespace AddCameraWizardModels {
    export enum WizardStep {
        CoreSelection = 0,
        DetectionMethod = 1,
        ScanSelection = 2,
        Authentication = 3,
        Configuration = 4
    }

    export enum DetectionMethod {
        Express = 'express',
        AddressRange = 'addressRange',
        OnvifSearch = 'onvifSearch',
        Manual = 'manual',
        CsvImport = 'csvImport',
    }

    export interface ManualCsvImportRow {
        name: string;
        ipAddress: string;
        port: number;
        username: string;
        password: string;
        mainUrl: string;
        subUrl: string;
        protocol?: LocationModel.RtspProtocol;
    }

    export interface WizardState {
        currentStep: WizardStep;
        locationId: string;
        selectedEdgeId: string | null;
        detectionMethod: DetectionMethod | null;
        scanProgress: number;
        isScanning: boolean;
    }

    export interface StepConfig {
        step: WizardStep;
        key: string;
        label: string;
    }

    export interface AddressRangeData {
        ipStart: string;
        ipEnd: string;
        port: number;
    }

    export enum SupportedCameraBrand {
        Hikvision = 'hikvision',
        Dahua = 'dahua',
        Uniview = 'uniview',
        Provision = 'provision',
    }

    export interface BrandStreamPaths {
        mainUrl: string;
        subUrl: string;
    }

    export const BRAND_DEFAULT_STREAM_PATHS: Record<SupportedCameraBrand, BrandStreamPaths> = {
        [SupportedCameraBrand.Hikvision]: {
            mainUrl: '/Streaming/Channels/101',
            subUrl: '/Streaming/Channels/102',
        },
        [SupportedCameraBrand.Dahua]: {
            mainUrl: '/cam/realmonitor?channel=1&subtype=0',
            subUrl: '/cam/realmonitor?channel=1&subtype=1',
        },
        [SupportedCameraBrand.Uniview]: {
            mainUrl: '/media/video1',
            subUrl: '/media/video2',
        },
        [SupportedCameraBrand.Provision]: {
            mainUrl: '/profile1',
            subUrl: '/profile2',
        },
    };
}
